/**
 * @file     appStoreLinks.ts
 * @purpose  App identifiers and store URLs. Kept apart from appLinks.ts (which carries the app-claimed path table built from every city) so the footer badges and store links stay light.
 */

export const APPLE_TEAM_ID = 'Q33NRZQY26';
export const IOS_BUNDLE_ID = 'ca.relta.mobile';
export const IOS_APP_ID = `${APPLE_TEAM_ID}.${IOS_BUNDLE_ID}`;
export const APP_STORE_ID = '6809333593';
export const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;
export const ANDROID_PACKAGE = 'ca.relta.mobile';
export const APP_URL_SCHEME = 'relta';

/** Public store listings, linked from the footer badges and the app prompt. */
export const APP_STORE_LISTING_URL = `https://apps.apple.com/ca/app/relta-real-estate/id${APP_STORE_ID}`;
export const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

/**
 * One link that sends a phone to its own store (src/app/get-app/route.ts). The
 * desktop app prompt's QR encodes it, so one code works for iPhone and Android.
 * It sits under /app/*, so a phone that already has the app opens the app.
 */
export const APP_DOWNLOAD_PATH = '/get-app';

export type StorePlatform = 'ios' | 'android';

export function storeListingUrl(platform: StorePlatform): string {
  return platform === 'android' ? GOOGLE_PLAY_URL : APP_STORE_LISTING_URL;
}
